const CONTACT_CODE_COOLDOWN_PREFIX = 'contact-code-cooldown'
export const CONTACT_CODE_RESEND_COOLDOWN_SECONDS = 60

const getContactCodeCooldownKey = (contact: string | number) =>
  `${CONTACT_CODE_COOLDOWN_PREFIX}:${String(contact).trim().toLowerCase()}`

// Бэкенд отдаёт код не чаще раза в 60 секунд: помним время последней отправки,
// чтобы таймер переживал перезагрузку страницы
export const setContactCodeCooldown = (
  contact: string | number,
  seconds: number = CONTACT_CODE_RESEND_COOLDOWN_SECONDS
) => {
  localStorage.setItem(
    getContactCodeCooldownKey(contact),
    String(Date.now() + seconds * 1000)
  )
}

export const getContactCodeCooldownSeconds = (contact: string | number) => {
  const expiresAt = Number(
    localStorage.getItem(getContactCodeCooldownKey(contact)) || 0
  )
  const secondsLeft = Math.ceil((expiresAt - Date.now()) / 1000)

  if (secondsLeft <= 0) {
    localStorage.removeItem(getContactCodeCooldownKey(contact))
    return 0
  }

  return secondsLeft
}
